<template>
  <div>
    <AddGPMModal :companyId="companyId" />
    <UpdateGPMModal :grpMgt="grpMgt" :companyId="companyId" />
    <MapToBranch
      :groupId="currentGroupId"
      :company="company"
      :companyID="companyID"
    />
    <!-- <GPMDetailsModal :waybillId="waybillId" /> -->
    <AdminMasterLayout>
      <div class="mt-3 full__row_section">
        <div class="row">
          <div class="col-md-8">
            <div class="py-5 pt-5 mb-3 row align-items-center white-bg">
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <img src="@/assets/img/deal.png" width="40px" />
                </div>
              </div>
              <div class="py-1 col-md-6">
                <h4 class="primary-color font-600">
                  {{ $t("text.iGroupManagement.groupManagement") }}
                </h4>
                <p class="mt-3 light-grey-text">
                  {{ $t("text.iGroupManagement.createAndManage") }}
                </p>
              </div>
              <div class="col-md-5 text_right">
                <button
                  class="add__new__retainership_btn"
                  style="border-radius: 6px; background-color: #370f70"
                  @click="addGPM"
                >
                  {{ $t("text.iGroupManagement.createNew") }}
                  <!-- <img
                    src="@/assets/img/git_loader.gif"
                    style="display: none"
                    width="35px"
                    height="35px"
                    class="ml-3 loader"
                  /> -->
                </button>
              </div>
              <div class="col-md-5 flexify"></div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.iGroupManagement.totalGroups") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/deal.png" width="40px" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ GPMCount }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowTextWrap="true"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="70" field="index" headerText="#"></e-column>
                <e-column
                  field="name"
                  width="150"
                  :headerText="$t('text.iGroupManagement.name')"
                ></e-column>
                <e-column
                  field="description"
                  width="200"
                  :headerText="$t('text.iGroupManagement.description')"
                ></e-column>
                <e-column
                  field="category"
                  width="150"
                  :headerText="$t('text.iGroupManagement.category')"
                ></e-column>
                <e-column
                  field="email"
                  width="250"
                  :headerText="$t('text.iGroupManagement.email')"
                ></e-column>
                <e-column
                  width="400"
                  :template="GroupsTemp"
                  headerText=""
                ></e-column>
                <e-column
                  width="100"
                  :template="buttonsTemplate"
                  :headerText="$t('text.iGroupManagement.action')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </AdminMasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import AdminMasterLayout from "@/views/Industrial/AdminMasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import AddGPMModal from "@/components/modals/GroupManagement/addGPMModal";
import UpdateGPMModal from "@/components/modals/GroupManagement/updateGPMModal";
import GroupsTemp from "@/components/Templates/industrygroupsTemp";
// import GPMDetailsModal from "@/components/modals/GroupManagement/GPMDetailsModal";
import MapToBranch from "@/components/modals/GroupManagement/mapGroupToBranch.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Industry Group Management :: Epump Portal",
  name: "Industry_Group_Management",
  components: {
    AdminMasterLayout,
    TableLoader,
    AddGPMModal,
    UpdateGPMModal,
    GroupsTemp,
    MapToBranch,
    // GPMDetailsModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      company: null,
      companyId: null,
      companyID: localStorage.getItem("companyID")
        ? localStorage.getItem("companyID")
        : this.$route.query.companyID,
      showLoader: true,
      GPMCount: 0,
      grpMgt: [],
      currentGroupId: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search", "ExcelExport", "PdfExport"],
      search: { operator: "contains", ignoreCase: true },
      GroupsTemp: function () {
        return {
          template: GroupsTemp,
        };
      },
      buttonsTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template:
              '<div class="btn-group btn-group-sm" role="group">' +
              '<button type="button" class="btn btn-warning" title="Update" @click="updateGPM(data)" >' +
              '<i class="fa fa-edit" aria-hidden="true"></i>' +
              "</button>" +
              '<button type="button" class="btn btn-danger" title="Delete" @click="deleteGPM(data.id)" >' +
              '<i class="fa fa-trash-o" aria-hidden="true"></i>' +
              "</button>" +
              "</div>",
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              updateGPM: function (grpMgt) {
                this.$eventHub.$emit("_updateGPM", grpMgt);
              },
              deleteGPM: function (id) {
                this.$eventHub.$emit("_deleteGPM", id);
              },
            },
          }),
        };
      },
    };
  },

  watch: {
    company(company) {
      if (company !== null) {
        this.getGPM();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
      // this.companyId = company.id;
    });
    if (this.$route.query.companyID) {
      this.getGPM();
      this.companyId = localStorage.getItem("companyID")
        ? localStorage.getItem("companyID")
        : this.$route.query.companyID;
      console.log(this.companyId);
    }
    this.$eventHub.$on("_updateGPM", (grpMgt) => {
      this.updateGPM(grpMgt);
    });
    this.$eventHub.$on("_deleteGPM", (id) => {
      this.deleteGPM(id);
    });
    this.$eventHub.$on("getGPM", () => {
      this.getGPM();
    });
    this.$eventHub.$on("_mapGroupToBranch", (id) => {
      this.mapToBranch(id);
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("_updateGPM");
    this.$eventHub.$off("_deleteGPM");
    this.$eventHub.$off("getGPM");
    this.$eventHub.$off("_mapGroupToBranch");
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    mapToBranch(id) {
      this.currentGroupId = id;
      this.$modal.show("mapGroupBranchModal");
    },
    addGPM() {
      this.$modal.show("addGPMModal");
    },
    updateGPM(grpMgt) {
      this.grpMgt = grpMgt;
      this.$modal.show("updateGPMModal");
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Group_Management_List.pdf",
          };
          this.$refs.dataGrid.getColumns()[0].width = "80";
          this.$refs.dataGrid.getColumns()[1].width = "200";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "200";
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          // this.$refs.dataGrid.getColumns()[4].visible = false;
          // this.$refs.dataGrid.getColumns()[5].visible = true;
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {},
    deleteGPM(id) {
      const remove = confirm("Delete Group?");
      if (!remove) {
        return;
      }
      this.axios
        .delete(
          `${configObject.apiBaseUrl}/GroupManagement/DeleteGroup/${id}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.$toast.open({
            message: "Group Deleted",
            type: "success",
            duration: 3000,
          });
          this.$eventHub.$emit("getGPM");
        })
        .catch((error) => {});
    },
    getGPM() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/GroupManagement/Group/${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          // console.log(response);
          this.showLoader = false;
          this.GPMCount = response.data.length;
          let index = 0;
          response.data.sort((a, b) => {
            return a.name > b.name ? 1 : -1;
          });
          response.data.forEach((element) => {
            element.index = ++index;
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
